import translations from "../translations/translations";

const languageHelpers = {
    getTranslation: lang => {
        // Convert language codes to expected values for translation
        switch (lang) {
            case "ge":
                lang = "de";
                break;
            case "cn":
                lang = "zh";
                break;
            default:
                break;
        }
        let content = translations[lang];
        if (!content) {
            content = translations["en"];
        }
        return content;
    }
}

export default languageHelpers;